import * as React from "react";

const PlusCircle: React.FC = () => {
    return (
        <svg
            focusable="false"
            xmlns="http://www.w3.org/2000/svg"
            width="17"
            height="17"
            viewBox="0 0 17 17"
            fill="currentColor"
            fillRule="nonzero"
            stroke="none"
        >
            <rect x="0.5" y="0.5" width="16" height="16" rx="8" />
            <path
                d="M8.88014 11.2527V8.88849H11.1666V8.12262H8.88014V5.74731H8.10872V8.12262H5.83331V8.88849H8.10872V11.2527H8.88014Z"
                fill="white"
            />
        </svg>
    );
};

export default React.memo(PlusCircle);
